<template>
<div class="mains-page">
  <div class="industry">
  <p class="indestry-lif">{{res1}} </p>
  <p class="indestry-w">Why choose us</p>
</div>
<div class="indus">
  <p class="indus-chan" v-if="res1 !=='碳立方的优势'">产品简介  <span> Product introduction</span></p>
  <p class="i-p">{{res2}}</p>
  <p class="i-p">{{res3}}</p>
  <p class="indus-chan1" v-if="res1 !=='碳立方的优势'">案例简介  <span> Case introduction</span></p>
  <p class="i-p">{{res4}}</p>
</div>
<img class="kongpai" :src="require('@/assets/advartages/' +formattedSrc)">
<img class="saas" src="../assets/advartages/yfw.png" alt="">
<p class="sp">SaaS云服务: 公有云 / 私有云部署</p>
<p class="cy">采用私有化架构方案，为客户提供更高效的业务落地产出，</p>
<p class="cy">更灵活的业务配置，更完善的管理，更优秀的客户体验</p>
<img class="saas" src="../assets/advartages/dsj.png" alt="">
<p class="sp">大数据</p>
<p class="cy">高效，高可靠，高容错及更高纠错能力的持续追踪，分析</p>
<p class="cy">和评价企业碳减排手段的效果，帮助企业<span>降本增效</span></p>
<img class="saas" src="../assets/advartages/qkljs.png" alt="">
<p class="sp">区块链技术</p>
<p class="cy">采用区块链技术确保<span>可信，开放，安全的碳交易和碳信用</span></p>
<img class="saas" src="../assets/advartages/tszlshgljsc.png" alt="">
<p class="sp">碳数字孪生和管理驾驶舱</p>
<div class="ss1"></div><p class="cy">运用数字孪生技术建设企业碳管理驾驶舱，支持客户</p>
<p class="cy">达成<span>“可见，可管，可预，可控”</span></p>
<div class="ss2"></div><p class="cy">ESG报告符合<span>中国国情并与国际接轨</span></p>
<img class="saas" src="../assets/advartages/zstpjss.png" alt="">
<p class="sp">AI认知：知识图谱技术</p>
 <div class="ss3"></div><p class="cy">内置8大行业24子行业的碳排放核算方法，支持国内</p>
 <p class="cy">最全面，规范的<span>碳排放因子库</span></p>
 <div class="ss4"></div><p class="cy">持续跟踪各交易所碳资产的<span>最新价格</span>，内置多种集团</p>
 <p class="cy">内和集团外的碳资产交易策略</p>
 <img class="saas" src="../assets/advartages/zstpjs.png" alt="">
 <p class="sp">AI感知：AIoT技术</p>
 <p class="cy">实时，精准，完备的自主算法，对各种排放源进行在线</p>
 <p class="cy">监测。降低工作的难度强度，为企业提供绿色，可</p>
 <p class="cy">持续发展的重要基础</p>
</div>
</template>
<script>
export default {
  props: {
    res1: {
      type: String,
      default: ''
    },
    res2: {
      type: String,
      default: ''
    },
    res3: {
      type: String,
      default: ''
    },
    res4: {
      type: String,
      default: ''
    },
    res5: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      formattedSrc: ''
    }
  },
  created () {
    this.formattedSrc = this.res5.slice(21)
  },
  mounted () {
    this.formattedSrc = this.res5.slice(21)
  }
}
</script>
<style scoped lang="scss">
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    margin-left: 15%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
@media screen and (min-width: 1920px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    margin-left: 375px;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 16px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    width: 1155px;
    // height: 952px;
  }
}
@media screen and (max-width:375px){
    .industry{
    text-align: center;
    margin-top:10px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 17px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 10px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 15px;
    .indus-chan{
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    // margin: 23px,20px, 23px, 20px;
    margin: 23px auto;
    width: 80%;
    // height: 340px;
  }
  .saas{
    width: 50px;
    height: 50px;
    margin: 20px auto;
  }
  .sp{
    color: #7dc0c1;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;
  }
  // .ss1{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1375px;
  //   left: 10px;
  // }
  // .ss2{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1433px;
  //   left: 49px;
  // }
  // .ss3{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1577px;
  //   left: 13px;
  // }
  // .ss4{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1633px;
  //   left: 10px;
  // }
  .cy{
    text-align: center;
    font-size: 14px;
    margin-bottom: 8px;
    span{
      font-size: 15px;
      font-weight: 1000;
    }
  }
}
@media screen and (max-width:414px) and (min-width: 391px) {
        .industry{
    text-align: center;
    margin-top:50px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:12px ;
      color: #9a9a9a;
      margin-bottom: 16px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right: 25px ;
    margin-bottom:50px ;
    .indus-chan{
      margin-top:44px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 12px;
      }
    }
    .indus-chan1{
      margin-top: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    // margin: 23px,20px, 23px, 20px;
    margin: 23px auto;
    width: 90%;
    // height: 391px;
  }
  .saas{
    width: 50px;
    height: 50px;
    margin: 20px auto;
  }
  .sp{
    color: #7dc0c1;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;
  }
  // .ss1{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1405px;
  //   top: 1516px;
  //   left: 17px;
  // }
  // .ss2{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1462px;
  //   top: 1574px;
  //   left: 57px;
  // }
  // .ss3{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1604px;
  //   top: 1715px;
  //   left: 18px;
  // }
  // .ss4{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1662px;
  //   top: 1773px;
  //   left: 16px;
  // }
  .cy{
    text-align: center;
    font-size: 14px;
    margin-bottom: 8px;
    span{
      font-size: 15px;
      font-weight: 1000;
    }
  }
}
@media screen and (max-width:1440px) and (min-width:1000px) {
    .industry{
    text-align: center;
    margin-top:10px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 17px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 10px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 15px;
    .indus-chan{
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    // margin: 23px,20px, 23px, 20px;
    margin: 53px auto;
    width: 85%;
    // height:1006px;
  }
  .saas{
    width: 50px;
    height: 50px;
    margin: 20px auto;
  }
  .sp{
    color: #7dc0c1;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;
  }
  // .ss1{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1747px;
  //   left: 197px;
  // }
  // .ss2{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1807px;
  //   left: 233px;
  // }
  // .ss3{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1951px;
  //   left: 199px;
  // }
  // .ss4{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 2011px;
  //   left: 192px;
  // }
  .cy{
    text-align: center;
    font-size: 14px;
    margin-bottom: 8px;
    span{
      font-size: 15px;
      font-weight: 1000;
    }
  }
}
@media screen and (max-width:1000px) and (min-width:768px) {
    .industry{
    text-align: center;
    margin-top:10px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 17px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 10px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 15px;
    .indus-chan{
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    // margin: 23px,20px, 23px, 20px;
    margin: 23px auto;
    width: 80%;
    // height:677px;
  }
  .saas{
    width: 50px;
    height: 50px;
    margin: 20px auto;
  }
  .sp{
    color: #7dc0c1;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;
  }
  // .ss1{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1937px;
  //   left: 197px;
  // }
  // .ss2{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 1995px;
  //   left: 233px;
  // }
  // .ss3{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 2136px;
  //   left: 199px;
  // }
  // .ss4{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   top: 2194px;
  //   left: 192px;
  // }
  .cy{
    text-align: center;
    font-size: 14px;
    margin-bottom: 8px;
    span{
      font-size: 15px;
      font-weight: 1000;
    }
  }
}
@media screen and (max-width:390px) and (min-width: 376px) {
        .industry{
    text-align: center;
    margin-top:50px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:12px ;
      color: #9a9a9a;
      margin-bottom: 16px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 27px;
    margin-right: 25px ;
    margin-bottom:50px ;
    .indus-chan{
      margin-top:44px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 12px;
      }
    }
    .indus-chan1{
      margin-top: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 12px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    // margin: 23px,20px, 23px, 20px;
    margin: 23px auto;
    width: 80%;
    // height: 339px;
  }
  .saas{
    width: 50px;
    height: 50px;
    margin: 20px auto;
  }
  .sp{
    color: #7dc0c1;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;
  }
  // .ss1{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1405px;
  //   top: 1516px;
  //   left: 17px;
  // }
  // .ss2{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1462px;
  //   top: 1574px;
  //   left: 57px;
  // }
  // .ss3{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1604px;
  //   top: 1715px;
  //   left: 18px;
  // }
  // .ss4{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1662px;
  //   top: 1773px;
  //   left: 16px;
  // }
  .cy{
    text-align: center;
    font-size: 12px;
    margin-bottom: 8px;
    span{
      font-size: 15px;
      font-weight: 1000;
    }
  }
}
@media screen and (max-width:767px) and (min-width: 415px) {
        .industry{
    text-align: center;
    margin-top:50px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:12px ;
      color: #9a9a9a;
      margin-bottom: 16px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right: 25px ;
    margin-bottom:50px ;
    .indus-chan{
      margin-top:44px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 12px;
      }
    }
    .indus-chan1{
      margin-top: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    // margin: 23px,20px, 23px, 20px;
    margin: 23px auto;
    width: 90%;
    // height: 391px;
  }
  .saas{
    width: 50px;
    height: 50px;
    margin: 20px auto;
  }
  .sp{
    color: #7dc0c1;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;
  }
  // .ss1{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1405px;
  //   top: 1516px;
  //   left: 17px;
  // }
  // .ss2{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1462px;
  //   top: 1574px;
  //   left: 57px;
  // }
  // .ss3{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1604px;
  //   top: 1715px;
  //   left: 18px;
  // }
  // .ss4{
  //   width: 10px;
  //   height: 10px;
  //   background-color: #7dc0c1;
  //   border-radius: 50%;
  //   position: absolute;
  //   // top: 1662px;
  //   top: 1773px;
  //   left: 16px;
  // }
  .cy{
    text-align: center;
    font-size: 14px;
    margin-bottom: 8px;
    span{
      font-size: 15px;
      font-weight: 1000;
    }
  }
}
</style>
